import {PricingCurrent} from "./PricingCurrent";
import {PricingOriginal} from "./PricingOriginal";
import {PricingDTO} from "./dto/PricingDTO";

export class Pricing
{
    private readonly _current?: PricingCurrent
    private readonly _original?: PricingOriginal
    private readonly _priceLabel?: string
    private readonly _discountLabel?: string

    private constructor(pricing: PricingDTO) {
        const v1 = pricing["version-1"];
        this._current = v1.current ? new PricingCurrent(v1.current) : null;
        this._original = v1.original ? new PricingOriginal(v1.original) : null;
        this._priceLabel = v1.price_label ? v1.price_label : null;
        this._discountLabel = v1.discount_label ? v1.discount_label : null;
    }

    static create(pricing: PricingDTO): Pricing | null {
        if (!pricing || !pricing["version-1"]) {
            return null;
        }
        return new Pricing(pricing);
    }

    get current(): PricingCurrent {
        return this._current;
    }

    get original(): PricingOriginal {
        return this._original;
    }

    get priceLabel(): string {
        return this._priceLabel;
    }

    get discountLabel(): string {
        return this._discountLabel;
    }

    get priceLabelOrCurrentPrice(): string | null {
        if(this._priceLabel !== null) {
            return this._priceLabel;
        }
        return this.current?.price.render() ?? '';
    }

    hasCurrent(): boolean {
        return this._current !== null;
    }

    hasOriginal(): boolean {
        return this._original !== null;
    }

    hasPriceLabelOrCurrentPrice(): boolean {
        return this._priceLabel !== null || this.hasCurrent();
    }
}
